import React, { Component } from 'react';
import { Pagination, Panel, Form, CheckBox, FormField, Dialog, NumberBox, Label, ButtonGroup, Messager, DataGrid, DateBox, GridColumn, LinkButton, ComboBox, TextBox, MaskedBox, Button } from 'rc-easyui';
import { API_URL } from '../../../../constants';
import { getAccessToken, getCookie } from '../../../../helpers/cookieHelper';
import axios from 'axios';
import { getUserId } from '../../../../helpers/AuthHelper';
import { isEmpty } from '../../../../helpers/Common';
import { getFormattedDate } from '../../../../helpers';

const utilizeFocus = () => {
    const ref = React.createRef()
    const setFocus = () => { ref.current && ref.current.focus() }

    return { setFocus, ref }
}

export class TimesheetSystemApproval extends Component {
    constructor(props) {
        super(props)
        this.state = {
            statusData: [{ value: "Submitted", text: "Submitted" }, { value: "Approved", text: "Approved" }, { value: "Rejected", text: "Rejected" }],
            pageArray: [],
            StatusList: [],
            pageOptions: {},
            searchparam: {
                fromdate: '',
                todate: '',
                projectId: "",
                subprojectId: "",
                status: "",
                comments: "",
                userId: "",
                enabled: true,
            },
            isLoading: false,
            pageOptions: {
                pageOptions: {
                    layout: [
                        "list",
                        "sep",
                        "first",
                        "prev",
                        "next",
                        "last",
                        "sep",
                        "refresh",
                        "sep",
                        "manual",
                        "info",
                    ],
                },
            },

            subprojectList: [],
            projectList: [],
            selected: {},
            editable: false,
            editingRow: null,
            model: {},
            title: '',
            closed: true,
            closed2:true,
            user: [],
            btn: null,
            btn2:null,
            permissions: {},
            viewPermission: false,
            checkAllData: false,
            check: false,
            approvalDataSet: []
        }
    }


    componentDidMount = async () => {
        var data = getCookie('permission');

        const date = new Date();
        let fullYear = date.getFullYear();
        let fullMonth = date.getMonth()
        let fullDay = date.getDate()
        let formattedDate = fullYear + '-' + (fullMonth + 1) + '-' + fullDay
        const today = formattedDate;

        const timestamp = date.getTime();
        const sevenDaysTimeStamp = timestamp - 7 * 24 * 60 * 60 * 1000;
        const sevenDaysDate = new Date(sevenDaysTimeStamp);
        let sfullYear = sevenDaysDate.getFullYear();
        let sfullMonth = sevenDaysDate.getMonth()
        let sfullDay = sevenDaysDate.getDate()
        let formattedFromDate = sfullYear + '-' + (sfullMonth + 1) + '-' + sfullDay

        if (JSON.parse(data).includes("hrm-view") && JSON.parse(data).includes("project-view")) {
            this.setState({ viewPermission: true }, () => { console.log(this.state.viewPermission); })
        }


        this.setState({
            permissions: JSON.parse(data),
            pageOptions: {
                loading: true,
                pageOptions: {
                    pageNumber: 1,
                    pageSize: 100,
                    pagePosition: 'bottom',
                    pageList: [10, 20, 30, 40, 50, 60, 70, 80],
                    layout: [
                        'list',
                        'sep',
                        'first',
                        'prev',
                        'next',
                        'last',
                        'sep',
                        'refresh',
                        'sep',
                        'manual',
                        'info',
                    ],
                },
            },
            searchparam: {
                fromdate: new Date(formattedFromDate),
                todate: new Date(today),
                projectId: "",
                subprojectId: "",
                status: "",
                comments: "",
                userId: "",
                enabled: true,
            },
            loginId: "",
            checkAllData: false


        },
          async  () => {
               await this.getProjectId()
              await  this.getSubProjectId()
               await this.getUsers()
              await  this.getData()
            })
    }

    getProjectId = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            // let url = API_URL + 'api/fetchallprojectInfo';
            let url = `${API_URL}api/getactivecomboforprojectinfo?enabled=1`
            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data.object

                        this.setState({
                            projectList: dataObject,
                            isLoading: false
                        })

                    } else {
                        this.setState({
                            projectList: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        projectList: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getProjectId()
            }
        }

    }

    getSubProjectId = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            // let url = API_URL + 'api/fetchallprojectInfo';
            let url = `${API_URL}api/getactivecomboforsubprojectinfo?enabled=1`

            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data.object

                        this.setState({
                            subprojectList: dataObject,
                            isLoading: false
                        })

                    } else {
                        this.setState({
                            subprojectList: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        subprojectList: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getSubProjectId()
            }
        }

    }

    getUsers = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            // let url = API_URL + 'api/fetchallprojectInfo';
            let url = `${API_URL}api/users`

            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data
                        var username = getCookie('username');
                        // console.log(dataObject);
                        dataObject.map(data => {
                            if (data.username === username) {
                                this.setState({
                                    loginId: data.id
                                })
                            }
                        })
                        this.setState({
                            user: dataObject,
                            isLoading: false
                        })
                        

                    } else {
                        this.setState({
                            user: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        user: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getUsers()
            }
        }
    }

    getData = async () => {
        const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
        const { fromdate, todate, projectId, subprojectId, status, enabled, comments, userId } = this.state.searchparam;

        var access_token = getCookie("access_token");
        var token_type = getCookie("token_type");
        let headerConfig = {
            headers: {
                authorization: token_type + " " + access_token,
                "Content-Type": "application/json",
            }
        }
        this.setState({
            isLoading:true
        })
        let enable = true;
        if (enabled) {
            enable = 1
        } else {
            enable = 0
        }
        var url = `${API_URL}api/gettimesheetsystemwithpagination?fromdate=${getFormattedDate(fromdate)}&todate=${getFormattedDate(todate)}&projectid=${projectId}&subprojectid=${subprojectId}&userid=${userId}&status=${status}&enabled=${enable}&page=${pageNumber}&rows=${pageSize}&loginid=`;
        this.setState({
            pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: true,
            },
        });
        if (access_token != null) {
            await axios.get(url, headerConfig)
                .then((response) => {
                    if (response.status === 200) {
                        let pageArr = response.data.rows.timesheetSystemlist;
                        pageArr = pageArr.filter(function (element) {
                            return element.status !== "Draft"
                        })
                        pageArr.map(data => {
                            this.state.projectList.map(projectlist => {
                                if (data.projectId === projectlist.id) {
                                    data.projectId = projectlist.name
                                }
                            })
                            this.state.subprojectList.map(subprojectlist => {
                                if (data.subprojectId === subprojectlist.id) {
                                    data.subprojectId = subprojectlist.name
                                }
                            })
                            let newdate = new Date(data.dateAd)
                            let fullYear = newdate.getFullYear()
                            let fullMonth = newdate.getMonth()
                            let fullDay = newdate.getDate()
                            newdate = fullYear + '-' + fullMonth + '-' + fullDay
                            data.dateAd = newdate
                        })

                        let total = response.data.total;

                        this.setState({
                            pageArray: pageArr,
                            pageOptions: {
                                pageOptions: {
                                    pageSize: 20,
                                    pageList: [20, 50, 30, 100, total].sort(
                                        function (a, b) {
                                            return a - b;
                                        }),
                                    total: total,
                                    ...this.state.pageOptions.pageOptions,
                                },
                                loading: false,
                            },
                            isLoading:false
                        });
                    } else {
                        this.setState({
                            pageOptions: {
                                pageOptions: { ...this.state.pageOptions.pageOptions },
                                loading: false,
                            },
                            isLoading:false
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        pageOptions: {
                            pageOptions: { ...this.state.pageOptions.pageOptions },
                            loading: false,
                        },
                        isLoading:false
                    });
                });
        } else {
            const resp = await getAccessToken();
            if (resp) {
                this.getData();
            }
        }
    }

    searchFieldOnChange = (name, e) => {
        let searchparam = Object.assign({}, this.state.searchparam)
        searchparam[name] = e
        this.setState({ searchparam: searchparam })
    }

    onPageChange = (event) => {

        this.setState(
            {
                pageOptions: {
                    pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
                    loading: true,
                },
            },
            function () {
                this.getData();
            }
        );

    }


    onSelectionChange = (selectedRow) => {
        if (selectedRow.status !== "Submitted") {
            this.setState({
                selected: selectedRow,
                editable: true,
            });
        } else {
            this.setState({
                selected: {}
            })
        }
    }

    handeleChange = (e) => {
        let temp = this.state.comments
        temp["comments"] = e.target.value;
        this.setState({
            comments: temp
        }, () => { console.log(this.state.comments); })
    }


    renderDialog() {
        const row = this.state.model;
        const { title, closed, rules } = this.state;
        return (
            <Dialog modal title={title} closed={closed} onClose={() => this.setState({ closed: true, btn: null })}>
                <div className="f-full" style={{ padding: '20px 50px' }}>
                    <Form className="f-full"
                        ref={ref => this.form = ref}
                        model={row}
                    >
                        <div style={{ marginBottom: 10 }}>
                            <Label htmlFor="itemid">Comment</Label>
                            <TextBox inputId="comments" name="comments" style={{ width: 220 }}></TextBox>
                        </div>
                    </Form>
                </div>
                <div className="dialog-button">
                    <LinkButton className="btn btn-primary" style={{ width: "80px", height: "35px", padding: "2px" }} onClick={() => this.handleUpdate(this.state.btn)}>{this.state.btn}</LinkButton>
                    <LinkButton className="btn btn-danger" style={{ width: "80px", height: "35px", padding: "2px" }} onClick={() => this.setState({ closed: true })}>Close</LinkButton>
                </div>
            </Dialog>
        )
    }

    renderDialog2() {
        const row = this.state.model;
        const { title, closed2, rules } = this.state;
        return (
            <Dialog modal title={title} closed={closed2} onClose={() => this.setState({ closed2: true, btn2: null })}>
                <div className="f-full" style={{ padding: '20px 50px' }}>
                    <Form className="f-full"
                        // ref={ref => this.form = ref}
                        model={row}
                    >
                        <div style={{ marginBottom: 10 }}>
                            <Label htmlFor="itemid">Comment</Label>
                            <TextBox inputId="comments" name="comments" style={{ width: 220 }}></TextBox>
                        </div>
                    </Form>
                </div>
                <div className="dialog-button">
                    <LinkButton className="btn btn-primary" style={{ width: "138px", height: "35px", padding: "2px" }} onClick={() => this.handleUpdateAll(this.state.btn2)}>{this.state.btn2}</LinkButton>
                    <LinkButton className="btn btn-danger" style={{ width: "80px", height: "35px", padding: "2px" }} onClick={() => this.setState({ closed2: true })}>Close</LinkButton>
                </div>
            </Dialog>
        )
    }


    editRow(row, data) {
        this.setState({
            editingRow: row,
            model: Object.assign({}, row),
            title: 'Timesheet ' + data,
            closed: false,
            btn: data
        });
    }

    handleUpdate = async (data) => {
        let token = getCookie("access_token");
        let tokenType = getCookie("token_type");
        let updateStatus = null
        if (data === "Approve") {
            updateStatus = "Approved"
        } else {
            updateStatus = "Rejected"
        }
        let updateData = {
            comments: this.state.model.comments,
            status: updateStatus,
            id: this.state.editingRow.id,
            loginId: this.state.loginId,
        }

        this.setState({ closed: true })

        console.log(updateData);
        let apiUrl = `${API_URL}api/savetimesheetstatus?id=${updateData.id}&status=${updateData.status}&comments=${updateData.comments}&loginid=${updateData.loginId}`;
        let headersConfig = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${tokenType} ${token}`,
            },
        };

        if (token != null) {
            //Access Token Available
            this.setState({
                isLoading: true,
            });
            axios
                .put(apiUrl, updateData, headersConfig)
                .then((response) => {
                    //  console.log(response)
                    if (response.status === 200) {
                        this.setState({
                            isLoading: false,
                        });
                        this.getData()
                        if (response.data.status) {

                            this.messager.alert({
                                title: "Success",
                                msg: response.data.message,
                                icon: "info",
                                reload: false,
                                buttons: [
                                    {
                                        text: "ok",
                                        onClick: () => {
                                            window.location.reload();
                                        },
                                    },
                                ],
                            }); // script detail  Saved Successfully ie. 200
                            // autoDissaperAction();
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: response.data.message,
                            });
                        }
                        // this.props.formClear();
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Uncaught Error",
                            reload: false,
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        isLoading: false,
                    });
                    this.messager.alert({
                        title: "Error",
                        msg: "Internal Server Error",
                        reload: false,
                    });
                    var response = error["response"];
                    if (response !== undefined) {
                        if (response.status === 400) {
                            var message = "";
                            response.data.errors.forEach((row, i) => {
                                message +=
                                    "<p style='margin-bottom:3px;'>" +
                                    row.field.toUpperCase() +
                                    " " +
                                    row.defaultMessage +
                                    "</p>";
                            });
                            this.messager.alert({
                                title: "Error",
                                msg: message,
                                reload: false,
                            }); // Backend Validation Error ie.400
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: "UnCaught Error",
                                reload: false,
                            }); // Uncaught Backend Error ie.500 eyc.
                        }
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Internal Server Error",
                            reload: false,
                        }); // Caused due to syntax error in front end
                    }
                });
        } else {
            //Access Token Expired.
            //Generate new Access Token using Refresh Token.
            const resp = await getAccessToken();
            if (resp) {
                this.handleUpdate();
            }
        }

    }
    handleUpdateAll = async (data) => {
        let token = getCookie("access_token");
        let tokenType = getCookie("token_type");
        let updateStatus = null
        if (data === "Approve selected") {
            updateStatus = "Approved"
        } else {
            updateStatus = "Rejected"
        }
        let ids=[]
        this.state.editingRow.map(d=>{
            ids.push(d.id)
        })
        let updateData = {
            comments: this.state.model.comments,
            status: updateStatus,
            id: ids,
            loginId: this.state.loginId,
        }

        this.setState({ closed2: true })

        console.log(updateData);
        let apiUrl = `${API_URL}api/updatetimesheetsystemacceptallandrejectallstatus?idinarray=${updateData.id}&status=${updateData.status}&comments=${updateData.comments}&loginid=${updateData.loginId}`;
        let headersConfig = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${tokenType} ${token}`,
            },
        };

        if (token != null) {
            //Access Token Available
            this.setState({
                isLoading: true,
            });
            axios
                .put(apiUrl, updateData, headersConfig)
                .then((response) => {
                    //  console.log(response)
                    if (response.status === 200) {
                        this.setState({
                            isLoading: false,
                        });
                        this.getData()
                        if (response.data.status) {

                            this.messager.alert({
                                title: "Success",
                                msg: response.data.message,
                                icon: "info",
                                reload: false,
                                buttons: [
                                    {
                                        text: "ok",
                                        onClick: () => {
                                            window.location.reload();
                                        },
                                    },
                                ],
                            }); // script detail  Saved Successfully ie. 200
                            // autoDissaperAction();
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: response.data.message,
                            });
                        }
                        // this.props.formClear();
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Uncaught Error",
                            reload: false,
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        isLoading: false,
                    });
                    this.messager.alert({
                        title: "Error",
                        msg: "Internal Server Error",
                        reload: false,
                    });
                    var response = error["response"];
                    if (response !== undefined) {
                        if (response.status === 400) {
                            var message = "";
                            response.data.errors.forEach((row, i) => {
                                message +=
                                    "<p style='margin-bottom:3px;'>" +
                                    row.field.toUpperCase() +
                                    " " +
                                    row.defaultMessage +
                                    "</p>";
                            });
                            this.messager.alert({
                                title: "Error",
                                msg: message,
                                reload: false,
                            }); // Backend Validation Error ie.400
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: "UnCaught Error",
                                reload: false,
                            }); // Uncaught Backend Error ie.500 eyc.
                        }
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Internal Server Error",
                            reload: false,
                        }); // Caused due to syntax error in front end
                    }
                });
        } else {
            //Access Token Expired.
            //Generate new Access Token using Refresh Token.
            const resp = await getAccessToken();
            if (resp) {
                this.handleUpdate();
            }
        }

    }
    handleCheckBoxChange = (checked, row) => {
        // this.getData()
        let tempData = this.state.approvalDataSet
        if (checked == false) {
            tempData = tempData.filter(data => data.id !== row.id)
            this.setState({
                approvalDataSet: tempData,
            }, () => {
                console.log(this.state.approvalDataSet);
                if (this.state.approvalDataSet.length == 0) {
                    this.setState({
                        check: false
                    },()=>{
                        console.log(this.state.approvalDataSet);
                    })
                }
            })
        }
        if(checked==true && (this.state.approvalDataSet.length!==this.state.pageArray.length)){
            this.setState({
                approvalDataSet:[...this.state.approvalDataSet,row]
            },()=>{
                console.log(this.state.approvalDataSet)
            })
        }
    }

    checkAll = (checked) => {
        if (this.state.checkAllData == false) {
            this.setState({
                checkAllData: true,
                check: true,
                approvalDataSet: this.state.pageArray
            }, async () => {
                console.log(this.state.approvalDataSet)
                await this.getData()
            })
        } else {
            this.setState({
                checkAllData: false,
                approvalDataSet:[]
            }, async () => {
                console.log(this.state.checkAllData)
                await this.getData()
            })
        }
    }

    submitAll=(data)=>{
        this.setState({
            editingRow: this.state.approvalDataSet,
            model: Object.assign({}, this.state.approvalDataSet[0]),
            title: 'Timesheet ' + data,
            closed2: false,
            btn2: data
        });
    }

    render() {
        const { total, pageNumber, pageSize } = this.state.pageOptions
        const { searchparam, isLoading, pageArray, permissions } = this.state
        const styles = { width: 110, height: 30 };
        return <div>
            {this.state.viewPermission === true ? (
                <div>
                    <Panel
                        title='Timesheet View'
                        bodyStyle={{ padding: 0 }}
                        style={{ height: 500 }}>
                        <Messager
                            ref={(ref) => (this.messager = ref)}
                            showHeader={false}
                            borderType='none'
                            content={({ title, msg, buttons, reload }) => (
                                <div className='alert-content'>
                                    <h3>{title}</h3>
                                    <div
                                        style={{ marginBottom: 5 }}
                                        dangerouslySetInnerHTML={{ __html: msg }}
                                    ></div>
                                    <div className='m-buttons'>
                                        {buttons.map((button, index) => (
                                            <LinkButton
                                                key={index}
                                                text={button.text}
                                                onClick={() => {
                                                    this.messager.close(button);
                                                    if (reload) {
                                                        window.location.reload();
                                                    }
                                                }}
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}
                        />
                        <div
                            className='loadingmodel'
                            style={{ display: isLoading ? "block" : "none" }}
                        ></div>
                        <DataGrid
                            data={pageArray}
                            clickToEdit
                            style={{ height: 'auto',maxHeight: 400 }}
                            // selectionMode='single'
                            // editMode='cell'
                            // pagination
                            // {...this.state.pageOptions}

                            // {...this.state.selected}
                            // onSelectionChange={(selection) =>
                            //     this.onSelectionChange(selection)
                            // }
                            // onPageChange={this.onPageChange}

                            toolbar={({ editingItem }) => (
                                <div style={{ padding: 4 }}>

                                    <b>User:</b>&nbsp;
                                    <ComboBox
                                        style={{ width: "110px", marginRight: "5px" }}
                                        data={this.state.user}
                                        valueField='id'
                                        textField='username'
                                        value={searchparam.userId}
                                        editable={false}
                                        onChange={(e) => this.searchFieldOnChange("userId", e)}
                                    ></ComboBox>
                                    &nbsp;

                                    <b>From date:</b>&nbsp;
                                    <DateBox
                                        format="yyyy-MM-dd"
                                        style={{ width: "150px", marginRight: "5px" }}
                                        value={searchparam.fromdate}
                                        onChange={(e) => this.searchFieldOnChange("fromdate", e)}
                                    >
                                    </DateBox>
                                    <b>To date:</b>&nbsp;
                                    <DateBox
                                        format="yyyy-MM-dd"
                                        style={{ width: "150px", marginRight: "5px" }}
                                        value={searchparam.todate}
                                        onChange={(e) => this.searchFieldOnChange("todate", e)}
                                    >
                                    </DateBox>

                                    <b>Project:</b>&nbsp;
                                    <ComboBox
                                        style={{ width: "130px", marginRight: "5px" }}
                                        data={this.state.projectList}
                                        valueField='id'
                                        textField='name'
                                        value={searchparam.projectId}
                                        editable={false}
                                        onChange={(e) => this.searchFieldOnChange("projectId", e)}
                                    ></ComboBox>
                                    &nbsp;

                                    <b>SubProject:</b>&nbsp;
                                    <ComboBox
                                        style={{ width: "130px", marginRight: "5px" }}
                                        data={this.state.subprojectList}
                                        valueField='id'
                                        textField='name'
                                        value={searchparam.subprojectId}
                                        editable={false}
                                        onChange={(e) => this.searchFieldOnChange("subprojectId", e)}
                                    ></ComboBox>
                                    &nbsp;

                                    <b>Status:</b>&nbsp;
                                    <ComboBox
                                        style={{ width: "100px", marginRight: "5px" }}
                                        data={this.state.statusData}
                                        value={searchparam.status}
                                        editable={false}
                                        onChange={(e) => this.searchFieldOnChange("status", e)}
                                    ></ComboBox>
                                    &nbsp;

                                    <LinkButton
                                        style={{ marginRight: "5px" }}
                                        iconCls="icon-search"
                                        plain
                                        onClick={this.getData}

                                    >
                                        Search
                                    </LinkButton>


                                </div>
                            )}>

                            <GridColumn width={30} field="sta" title={<CheckBox onChange={(checked)=>this.checkAll(checked)} checked={this.state.check}></CheckBox>}
                                render={({ row }) => (

                                    <div>
                                        <CheckBox onChange={(checked) => this.handleCheckBoxChange(checked, row)} checked={this.state.checkAllData}></CheckBox>
                                    </div>
                                )}
                            ></GridColumn>
                            <GridColumn width={80} field="dateBs" title="Date" editable={this.state.editable}></GridColumn>
                            <GridColumn width={120} field="projectId" title="Project" editable={this.state.editable}
                                editor={({ row }) => (
                                    <ComboBox data={this.state.projectList}
                                        valueField='name'
                                        textField='name'
                                        value={searchparam.projectId}></ComboBox>
                                )}
                            ></GridColumn>
                            <GridColumn width={120} field="subprojectId" title="Sub-Project" editable={this.state.editable}></GridColumn>
                            <GridColumn width={180} field="description" title="Description" editable={this.state.editable}
                                header={() => <span>Description</span>}
                                render={({ row }) => (
                                    <div title={row.description}>{row.description}</div>
                                )}
                            ></GridColumn>
                            <GridColumn width={50} field="timeSpent" title="Timespent" editable={this.state.editable}></GridColumn>
                            {/* <GridColumn width={130} field="comments" title="Comments" editable={this.state.editable}></GridColumn> */}
                            <GridColumn width={120} field="sta" title="Status"
                                render={({ row }) => (

                                    <div>
                                        {row.status === "Approved" ? (
                                            <ButtonGroup>
                                                <LinkButton className="btn btn-sm btn-success rounded" style={{ marginRight: "10px" }}>Approved&nbsp;</LinkButton>
                                                <LinkButton className="btn btn-sm btn-primary rounded" style={{ marginRight: "10px", width: "86px" }} onClick={() => this.editRow(row, "Reject")}>Reject</LinkButton>
                                            </ButtonGroup>
                                        ) : row.status === "Rejected" ? (
                                            <ButtonGroup>
                                                <LinkButton className="btn btn-sm btn-primary rounded" style={{ marginRight: "10px", width: "94px" }} onClick={() => this.editRow(row, "Approve")}>Approve&nbsp;</LinkButton>
                                                <LinkButton className="btn btn-sm btn-danger rounded" style={{ marginRight: "10px" }}>Rejected&nbsp;</LinkButton>
                                            </ButtonGroup>
                                        ) : (
                                            <ButtonGroup>
                                                <LinkButton className="btn btn-sm btn-primary rounded" style={{ marginRight: "10px", width: "94px" }} onClick={() => this.editRow(row, "Approve")}>Approve&nbsp;</LinkButton>
                                                <LinkButton className="btn btn-sm btn-primary rounded" style={{ marginRight: "10px", width: "86px" }} onClick={() => this.editRow(row, "Reject")}>Reject</LinkButton>
                                            </ButtonGroup>
                                        )

                                        }




                                    </div>
                                )}
                            ></GridColumn>


                        </DataGrid>
                        <div className='d-flex justify-content-between mt-2'>
                            <div></div>
                            <div>
                                <ButtonGroup>
                                    <LinkButton onClick={() => this.submitAll("Approve selected")} disabled={this.state.approvalDataSet.length>0?false:true} className="btn btn-sm btn-primary rounded" style={{ marginRight: "10px", width: "138px" }}>Approve selected&nbsp;</LinkButton>
                                    <LinkButton onClick={() => this.submitAll("Reject selected")} disabled={this.state.approvalDataSet.length>0?false:true} className="btn btn-sm btn-primary rounded" style={{ marginRight: "10px", width: "120px" }}>Reject selected</LinkButton>
                                </ButtonGroup>
                            </div>
                            <div></div>
                        </div>
                        {this.renderDialog()}
                        {this.renderDialog2()}
                    </Panel>
                </div>
            ) : ""}



        </div>;
    }
}

export default TimesheetSystemApproval;
